var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tag-discount rounded-circle d-flex flex-column align-items-center justify-content-center"},[_c('div',[_vm._v("SAVE")]),_c('div',[_vm._v(_vm._s(_vm.discount)+"%")])])}
var staticRenderFns = []

export { render, staticRenderFns }